import React from 'react';
import AdUnit, { useAds } from './AdUnit';

const DesktopAdBanner = ({ position, className = '' }) => {
  const ads = useAds(position, 10);

  if (!ads.length) return null;

  return (
    <div className={`desktop-ads-stack desktop-ads-${position} ${className}`.trim()}>
      {ads.map((ad) => (
        <AdUnit
          key={ad._id}
          ad={ad}
          variant="sidebar"
          className="desktop-ad-banner"
        />
      ))}
    </div>
  );
};

export default DesktopAdBanner;
